// Estonian translations
export const et: Record<string, string> = {
  'menu.dashboard': 'Töölaud', 'menu.orderNew': 'Toote registreerimine', 'menu.customers': 'Kliendid', 'menu.products': 'Tooted', 'menu.users': 'Kasutajad', 'menu.settings': 'Seaded', 'menu.logout': 'Logi välja',
  'dashboard.title': 'Töölaud', 'dashboard.todaySales': 'Tänane müük', 'dashboard.totalOrders': 'Tellimused kokku', 'dashboard.newOrder': 'Uus tellimus', 'dashboard.newCustomer': 'Uus klient',
  'order.title': 'Uus tellimus', 'order.customer': 'Klient', 'order.products': 'Tooted', 'order.quantity': 'Kogus', 'order.price': 'Hind', 'order.total': 'Kokku', 'order.payment': 'Makse', 'order.cash': 'Sularaha', 'order.card': 'Kaart',
  'users.title': 'Kasutajad', 'users.name': 'Nimi', 'users.email': 'E-post', 'users.role': 'Roll', 'users.edit': 'Muuda', 'users.delete': 'Kustuta',
  'common.yes': 'Jah', 'common.no': 'Ei', 'common.cancel': 'Tühista', 'common.save': 'Salvesta', 'common.search': 'Otsi', 'common.loading': 'Laadimine...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy', 'login.login': 'Logi sisse', 'login.enterPin': 'Sisesta PIN', 'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Registreerimine', 'signup.createAccount': 'Loo konto', 'signup.email': 'E-post', 'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Aruanded ja raamatupidamine',
  'menu.systemAndCommunication': 'Süsteem ja suhtlus',
};
